// @flow
import React, { useContext, useState } from 'react';
import {
    Modal,
    Form,
    Button,
    Popover,
    Input,
    Select,
    Space,
    Tooltip,
    message,
    Upload,
    notification,
    Typography,
    Drawer,
    Timeline
} from 'antd';
import {
    SaveOutlined,
    HomeOutlined,
    QuestionOutlined,
    ImportOutlined,
    ExportOutlined,
    PlusSquareOutlined,
    ReloadOutlined,
    StopOutlined,
    HistoryOutlined,
    PoweroffOutlined,
    DownloadOutlined,
    ExclamationCircleOutlined
} from '@ant-design/icons';

import {
    FILE_PATH,
    PageMode,
    setPageMode,
    IsPageDirty,
    setIsPageDirty,
    setIsPageLoading,
    RelativePath,
    CURRENT_USER
} from './GlobalParams';
import { baseUrl } from './RestHandler';
import reqwest from 'reqwest';
import axios from 'axios';

import type { T_Highlight, T_NewHighlight } from '../../src/types';
import { dataService } from './dataService';
import { covertToDaysJS } from './firebase';

type T_ManuscriptHighlight = T_Highlight;

//#region Global Members

let AppInstance = null;

const helpContent = (
    <div>
        <p>To create area highlight hold [Alt] key, then click and drag.</p>
    </div>
);

const getNextId = () => String(Math.random()).slice(2);

const buttonProps = {
    size: 'medium'
};

const uploadProps = {
    name: 'files',
    accept: `${
        CURRENT_USER.admin ? '.json,' : ''
    }.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel`,
    showUploadList: false,
    method: 'POST',
    beforeUpload: (file: File) => {
        AppInstance.props.setIsGetDataLoading(true, `Please wait ...`);
        var fileName = file.name;
        //Migration if json
        if (fileName.toLowerCase().endsWith('.json')) {
            const reader = new FileReader();
            reader.onload = (event) => {
                let newHighlights = JSON.parse(event.target.result);
                newHighlights.forEach((item) => {
                    item.fileId = AppInstance.props.fileId;
                    item.old_Id = item._id;
                    delete item._id;
                });
                console.log(newHighlights);
                dataService.firestore
                    .collection('docMarkers')
                    .set(newHighlights)
                    .then((response) => {
                        dataService.firestore
                            .collection('docMarkers')
                            .where('fileId', '==', AppInstance.props.fileId)
                            .get()
                            .then((data) => {
                                AppInstance.props.setIsGetDataLoading(
                                    true,
                                    `Refreshing data ...`
                                );
                                data.forEach((item) => {
                                    item.id = item._id;
                                });
                                AppInstance.props.importHighlights(data);
                                message.success(
                                    `${AppInstance.state.uploadFile.name} file uploaded and saved successfully`
                                );
                                AppInstance.props.setIsGetDataLoading(
                                    false,
                                    ''
                                );
                            });
                    });
            };
            reader.readAsText(file);
            return false;
        }

        AppInstance.setState({ uploadFile: file });

        dataService.firestore
            .collection('importExcels')
            .where('fileId', '==', AppInstance.props.fileId)
            .where('fileName', '==', file.name)
            .get()
            .then((data: Object[]) => {
                let isExist =
                    data &&
                    data.length > 0 &&
                    data.findIndex((a) => a.fileName === file.name) !== -1;
                if (isExist) {
                    AppInstance.props.setIsGetDataLoading(false);
                    AppInstance.setState({
                        confirmUpload: true,
                        existFile: data[0]
                    });
                } else {
                    AppInstance.props.setIsGetDataLoading(false);
                    //First Upload no cofirmation required
                    if (data.length === 0) {
                        AppInstance.setState({
                            confirmUpload: false,
                            existFile: {}
                        });
                        uploadProps.upload();
                    } else {
                        AppInstance.setState({
                            confirmUpload: true,
                            existFile: {}
                        });
                    }
                }
            });

        return false;
    },
    upload() {
        AppInstance.props.setIsGetDataLoading(true, `Please wait ...`);

        // Create an object of formData
        const formData = new FormData();

        // Update the formData object
        formData.append(
            'files',
            AppInstance.state.uploadFile,
            AppInstance.state.uploadFile.name
        );

        // Request made to the backend api
        // Send formData object
        axios
            .post(uploadProps.action, formData, {
                headers: uploadProps.headers,
                onUploadProgress: uploadProps.onUploadProgress
            })
            .then((response) => {
                if (response && response.data) {
                    let data = response.data;
                    data.forEach((item) => {
                        item.fileId = AppInstance.props.fileId;
                        item.position = item.position || { pageNumber: -1 };
                    });

                    let highlights = AppInstance.state.existFile.fileName
                        ? AppInstance.props.highlights
                        : [];

                    let newHighlights = processImportData(highlights, data);

                    AppInstance.props.setIsGetDataLoading(
                        true,
                        `Saving data ...`
                    );

                    dataService.firestore
                        .collection('docMarkers')
                        .set(newHighlights)
                        .then((response) => {
                            dataService.firestore
                                .collection('docMarkers')
                                .where('fileId', '==', AppInstance.props.fileId)
                                .get()
                                .then((data) => {
                                    AppInstance.props.setIsGetDataLoading(
                                        true,
                                        `Refreshing data ...`
                                    );
                                    data.forEach((item) => {
                                        item.id = item._id;
                                    });
                                    AppInstance.props.importHighlights(data);
                                    message.success(
                                        `${AppInstance.state.uploadFile.name} file uploaded and saved successfully`
                                    );
                                    AppInstance.props.setIsGetDataLoading(
                                        false,
                                        ''
                                    );
                                });
                        });
                } else {
                    message.success(`Import template error.`);
                    AppInstance.props.setIsGetDataLoading(false, '');
                }
                AppInstance.setState({
                    uploadFile: {},
                    existFile: {}
                });
            })
            .catch(() => {
                message.error(
                    `${AppInstance.state.uploadFile.name} file upload failed. Please contact support team.`
                );
                AppInstance.props.setIsGetDataLoading(false, '');
                AppInstance.setState({
                    uploadFile: {},
                    existFile: {}
                });
            });
    },
    onUploadProgress(event: ProgressEvent) {
        var bytesTrans = (event.loaded / (1024 * 1024)).toFixed(2);
        var totalBytes = (event.total / (1024 * 1024)).toFixed(2);
        let progress = ((bytesTrans / totalBytes) * 100).toFixed();
        if (progress < 100)
            AppInstance.props.setIsGetDataLoading(
                true,
                `${progress}% uploaded (${bytesTrans} MB of ${totalBytes} MB)`
            );
        else AppInstance.props.setIsGetDataLoading(true, `Processing...`);
    }
};

const processImportData = (
    oldHighlights: Array<T_Highlight>,
    newHighlights: Array<T_Highlight>
) => {
    AppInstance.props.setIsGetDataLoading(true, `Processing data ...`);
    return newHighlights.map((newItem) => {
        var oldIndex = oldHighlights.findIndex((a) => a.row == newItem.row);
        if (oldIndex >= 0) {
            var oldItem = oldHighlights[oldIndex];
            oldItem.importPageNo = newItem.importPageNo;
            oldItem.partNo = newItem.partNo;
            oldItem.positionNo = newItem.positionNo;
            oldItem.itemDesc = newItem.itemDesc;
            oldItem.plateNo = newItem.plateNo;
            oldItem.eqNo = newItem.eqNo;
            oldItem.eqName = newItem.eqName;
            oldItem.itemSpec = newItem.itemSpec;
            return oldItem;
        } else {
            return newItem;
        }
    });
};

const getFilePath = () => {
    return RelativePath;
};

//#endregion Global Member
let hidemsg;
export default class Toolbar extends React.Component {
    //#region Class Members
    state = {
        confirmUpload: false,
        uploadFile: {},
        existFile: {},
        showHistory: false,
        historyData: []
    };

    onSave = (e) => {
        hidemsg = message.warn('Please wait ...', 0);
        let updHighlights = this.props.highlights.filter((h) => {
            return h.content && h.content.image;
        });

        dataService.firestore
            .collection('docMarkers')
            .set(updHighlights)
            .then((response) => {
                hidemsg();
                message.success('Saved Successfully');
                this.props.afterSave();
            });
    };

    onDiscard = (e) => {
        this.props.reloadData();
    };

    onAddOrCancel = (e) => {
        if (PageMode == 'ReadOnly') {
            setPageMode('Add');
            let highlightId = getNextId();
            this.props.setSelectedHighlightId(highlightId);
            location.hash = `highlight-${highlightId}`;
            hidemsg = message.info('Add : Please mark the area.');
        } else {
            setPageMode('ReadOnly');
            this.props.setSelectedHighlightId('');
            location.hash = '';
            hidemsg();
        }
    };

    //#endregion something

    render() {
        uploadProps.action = new URL(
            '/Home/UploadFile?fileId=' + this.props.fileId,
            baseUrl
        ).toString();

        let token = localStorage.getItem('_auth');
        uploadProps.headers = {
            Authorization: `Bearer ${token}`
        };

        return (
            <React.Fragment>
                <Space>
                    <Tooltip title="Home">
                        <Button
                            type="primary"
                            icon={<HomeOutlined />}
                            {...buttonProps}
                            onClick={() => {
                                location.href = '/';
                            }}
                        />
                    </Tooltip>

                    <Tooltip title="Save">
                        <Button
                            type="primary"
                            icon={<SaveOutlined />}
                            disabled={PageMode != 'ReadOnly' || !IsPageDirty}
                            onClick={this.onSave}
                            {...buttonProps}
                        ></Button>
                    </Tooltip>

                    <Tooltip title="Discard">
                        <Button
                            type="primary"
                            icon={<ReloadOutlined />}
                            disabled={PageMode != 'ReadOnly' || !IsPageDirty}
                            onClick={this.onDiscard}
                            {...buttonProps}
                        ></Button>
                    </Tooltip>
                    <Tooltip title="Download User Manual">
                        <Button
                            type="primary"
                            icon={<DownloadOutlined />}
                            onClick={() => {
                                var link = document.createElement('a');
                                link.download = this.props.fileRef.name;
                                link.href = this.props.fileRef.downloadURL;
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                                link = null;
                            }}
                            {...buttonProps}
                        ></Button>
                    </Tooltip>

                    <Upload {...uploadProps}>
                        <Tooltip
                            title="Import Excel (Spare Parts Import Template)"
                            placement="bottomLeft"
                        >
                            <Button
                                type="primary"
                                icon={<ImportOutlined />}
                                disabled={IsPageDirty}
                                {...buttonProps}
                            ></Button>
                        </Tooltip>
                    </Upload>

                    <Tooltip title="Import History">
                        <Button
                            type="primary"
                            icon={<HistoryOutlined />}
                            disabled={IsPageDirty}
                            onClick={async () => {
                                this.setState({ showHistory: true });
                                let data = await dataService.firestore
                                    .collection('importExcels')
                                    .where(
                                        'fileId',
                                        '==',
                                        AppInstance.props.fileId
                                    )
                                    .get();
                                this.setState({ historyData: data });
                            }}
                            {...buttonProps}
                        ></Button>
                    </Tooltip>

                    <Tooltip title="Sign out">
                        <Button
                            type="primary"
                            icon={<PoweroffOutlined />}
                            disabled={IsPageDirty}
                            onClick={() => {
                                localStorage.clear();
                                location.href = '/';
                            }}
                            {...buttonProps}
                        ></Button>
                    </Tooltip>
                </Space>

                <Modal
                    title="Confirm Import!"
                    visible={this.state.confirmUpload}
                    onOk={() => {
                        uploadProps.upload();
                        this.setState({ confirmUpload: false });
                    }}
                    onCancel={() => {
                        this.setState({ confirmUpload: false });
                    }}
                    okText={
                        this.state.existFile.fileName ? 'Overwrite' : 'Insert'
                    }
                    cancelText="Cancel"
                    icon={<ExclamationCircleOutlined />}
                >
                    {this.state.existFile.fileName ? (
                        <div>
                            Already imported file!
                            <br />
                            <Typography.Text type="danger">
                                {' '}
                                {this.state.existFile.fileName}
                            </Typography.Text>{' '}
                            <Typography.Text type="secondary">
                                uploaded{' '}
                                {covertToDaysJS(this.state.existFile.dateTime)}
                            </Typography.Text>
                            <Button
                                download
                                type="link"
                                href={this.state.existFile.blobUrl}
                            >
                                {' '}
                                Download{' '}
                            </Button>
                            <br />
                            Do you want to overwrite the existing data?
                        </div>
                    ) : (
                        <div>
                            New import file!
                            <br />
                            <Typography.Text type="warning">
                                {' '}
                                {this.state.uploadFile.name}
                            </Typography.Text>{' '}
                            <br />
                            Do you want to add the new data?
                        </div>
                    )}
                </Modal>

                <Drawer
                    title="Import History"
                    placement="right"
                    width={512}
                    closable={true}
                    onClose={() => {
                        this.setState({ showHistory: false });
                    }}
                    visible={this.state.showHistory}
                >
                    <Timeline mode="right" reverse>
                        {this.state.historyData.map(function (d, idx) {
                            return (
                                <Timeline.Item key={d.id}>
                                    <a href={d.blobUrl} download>
                                        {d.fileName}
                                    </a>
                                    <br />
                                    <Typography.Text type="secondary">
                                        {' '}
                                        {covertToDaysJS(d.dateTime)}
                                    </Typography.Text>
                                </Timeline.Item>
                            );
                        })}
                    </Timeline>
                </Drawer>
            </React.Fragment>
        );
    }

    componentDidMount() {
        AppInstance = this;
    }
}



// WEBPACK FOOTER //
// ./demo/src/Toolbar.js